import React, { Fragment } from 'react';
import { CommonIcons } from 'components/Icons';
import NewDesign from 'components/NewDesign';
import { SIZE_ICON } from 'consts/data';

const propTypes = {};

const ButtonSearchAndReset = ({
  onClickSearch,
  onClickReset,
  isSearching,
  hideButtonSubmit,
  classNameSearchBtn,
  classNameResetBtn,
}) => {
  //! State

  //! Function

  //! Render
  return (
    <Fragment>
      {!hideButtonSubmit && (
        <NewDesign.Button
          type='submit'
          isLoading={isSearching}
          disabled={isSearching}
          onClick={onClickSearch}
          className={classNameSearchBtn}
        >
          <CommonIcons.Search size={SIZE_ICON} /> Search
        </NewDesign.Button>
      )}

      <NewDesign.Button
        type='button'
        variant='ghost'
        disabled={isSearching}
        onClick={onClickReset}
        className={classNameResetBtn}
      >
        <CommonIcons.Refresh size={SIZE_ICON} />
        <NewDesign.Typography>Reset</NewDesign.Typography>
      </NewDesign.Button>
    </Fragment>
  );
};

ButtonSearchAndReset.propTypes = propTypes;
export default ButtonSearchAndReset;
